import { render } from "./DropzoneComponent.vue?vue&type=template&id=5d692431"
import script from "./DropzoneComponent.vue?vue&type=script&lang=js"
export * from "./DropzoneComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__